import React from 'react';
import {cn} from "../utils/style";

function Button({type, children, onClick, secondary, className, disabled}) {
	return (<button
		onClick={e => {
			e.preventDefault();
			if (disabled) return;
			onClick(e);
		}}
		type={type || 'button'}
		disabled={disabled || false}
		className={cn(
			"inline-flex items-center rounded-full text-sm px-5 py-2.5 text-center font-semibold text-white shadow-sm transform transition-all duration-200 ease-in-out hover:shadow-md hover:translate-y-[-1px] active:translate-y-[0px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500",
			{
				'bg-red-500 hover:bg-red-400': secondary,
				'bg-[#0b6a8c] hover:bg-cyan-500': !secondary
			},
			className,
			{
				'!bg-gray-400 cursor-not-allowed hover:translate-y-0 hover:shadow-sm': disabled
			}
		)}
	>
		{children}
	</button>);
}

export default Button;
